// @react-functional

import React, { ComponentProps, ComponentType, FC } from 'react';
import { ModalContext } from '../../ModalContext';
import { RestrictedModal } from './RestrictedModal';

export type WithRestrictedModalProps = {
  openRestrictedModal: (source: string) => void;
};

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
type Subtract<T extends K, K> = Omit<T, keyof K>;

export function withRestrictedModal<
  P extends ComponentType<ComponentProps<P> & WithRestrictedModalProps>,
  ResolvedProps = JSX.LibraryManagedAttributes<
    P,
    Subtract<React.ComponentProps<P>, WithRestrictedModalProps>
  >
>(WrappedComponent: P) {
  const ComponentWithRestrictedModal: FC<ResolvedProps> = props => (
    <ModalContext.Consumer>
      {({ openModal }) => (
        <WrappedComponent
          {...(props as JSX.LibraryManagedAttributes<
            P,
            React.ComponentProps<P>
          >)}
          openRestrictedModal={(source: string) =>
            openModal(modalProps => (
              <RestrictedModal source={source} {...modalProps} />
            ))
          }
        />
      )}
    </ModalContext.Consumer>
  );
  return ComponentWithRestrictedModal;
}
